import { Box } from "@mui/material";
import styled from "styled-components";
import Zoom from "../../assets/icons/zoom.svg?react";

export const GridContainer = styled( Box )`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 48px;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      gap: 0;
    }
  `;

export const LicenceCell = styled( Box ) <{
  isLastColumn: boolean;
  isLastRow: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-right: ${ ( { isLastColumn } ) =>
    isLastColumn ? "0px" : "48px" };
    border-right: ${ ( { isLastColumn } ) =>
    isLastColumn ? "none" : "1px solid #6E6353" };

    @media (max-width: 900px) {
        &:nth-child(3) {
         border-right: none;
        }

        &:nth-child(5) {
         border-right: 1px solid #6E6353;
        }

        &:nth-child(6) {
         border-right: none;
        }
    }
    @media (max-width: 600px) {
      border-right: none;
      margin-bottom: 40px;
      &:nth-child(5) {
         border-right: none;
        }
    }

    

    & + & {
        padding-left: 48px;

        @media (max-width: 900px) {
        padding-left: 0;
        
    }
    }

    &:last-child {
    padding-right: 0;
    border-right: none;
  }
  `;

export const ImageWrapper = styled( Box )`
    position: relative;
    width: 212px;
    height: 300px;
    flex-shrink: 0;
    background: #fff;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 100%;
        height: 523px;
    }
  `;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  `;

export const Overlay = styled( Box )`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    ${ ImageWrapper }:hover & {
      opacity: 1;
    }

    @media (max-width: 600px) {
        left: 0;
        right: 0;
        top: 470px;
        width: 100%;
        height: 56px;
        display: flex;
        justify-content: flex-end;
    }
  `;

export const TitleText = styled.p`
    font-size: 24px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 12px;
    letter-spacing: 0%;
    line-height: 110%;
    padding: 12px 0px;
  `;

export const ZoomIcon = styled( Zoom )`
    width: 50px;
    height: 50px;

    @media (max-width: 600px) {
       width: 40px;
        height: 40px;
    }
  `;
